import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import Details from '../../../Interview/DetailsNew.js';
import { useSelector } from 'react-redux';


const ClosingCostFeeModal = ({
    show,
    onHide,
    filterParams,
    selectedLoan,
    detailedCard,
    closingCostsDetail,
    detailType,
}) => {
    const [isExporting, setIsExporting] = useState(false);

    const exportPDF = () => {
        setIsExporting(true);
        
        import('jspdf').then(({ default: jsPDF }) => {
            import('html2canvas').then(({ default: html2canvas }) => {
                const pdf = new jsPDF('p', 'mm', 'a4');
                const detailsComponent = document.querySelector('.loandetails .modal-body');
                
                if (!detailsComponent) {
                    console.error('Could not find Details component');
                    setIsExporting(false);
                    return;
                }
                
                const tabLinks = detailsComponent.parentElement.querySelectorAll('.nav-link');
                
                // Always switch to Closing Cost Details tab first
                tabLinks[0].click();
                
                // Wait a bit for the first tab to render
                setTimeout(() => {
                    const closingCostDetails = detailsComponent.querySelector('.tab-pane.active');
                    
                    html2canvas(closingCostDetails).then(canvas => {
                        const imgData = canvas.toDataURL('image/png');
                        const imgWidth = 210; // A4 width in mm
                        const imgHeight = canvas.height * imgWidth / canvas.width;

                        // Add "Closing Cost Details" title for the first page
                        pdf.setFontSize(18);
                        pdf.setFont(undefined, 'bold');
                        pdf.text('Closing Cost Details', 105, 20, { align: 'center' });
                        
                        pdf.addImage(imgData, 'PNG', 0, 30, imgWidth, imgHeight);
                        
                        // Save the PDF
                        pdf.save('Estimated Fee Sheet.pdf');
                        setIsExporting(false);
                    }).catch(err => {
                        console.error('Error generating PDF:', err);
                        setIsExporting(false);
                    });
                }, 300);
            }).catch(err => {
                console.error('Error importing html2canvas:', err);
                setIsExporting(false);
            });
        }).catch(err => {
            console.error('Error importing jsPDF:', err);
            setIsExporting(false);
        });
    };

    return (
        <Modal 
            show={show} 
            dialogClassName="loandetails mt-5"
            onHide={onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title className="d-flex justify-content-between w-100">
                    <div style={{
                        fontSize: 24, 
                        fontWeight: 'bold', 
                        color: 'white', 
                        fontFamily: 'Inter'
                    }}>
                        Estimated Fee Sheet
                    </div>
                    <div className="d-flex align-items-center">
                        <Button 
                            variant="secondary" 
                            onClick={() => exportPDF()} 
                            className="mr-auto"
                        >
                            {isExporting ? <Spinner animation='border' size='sm'/> : 'Export'}
                        </Button>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {detailedCard && selectedLoan ? (
                    <Details 
                        filterParams={{
                            ...filterParams,
                            loanAmount: selectedLoan.loanAmount || 400000,
                            propertyValue: filterParams.propertyValue || 500000,
                            downPayment: filterParams.downPayment || 100000,
                            purpose: filterParams.purpose || "Purchase"
                        }}
                        selection={{
                            ...selectedLoan, 
                            estimatedclosingcosts: closingCostsDetail || detailedCard.closing_costs_detail,
                            loanAmount: selectedLoan.loanAmount || filterParams.loanAmount || 400000,
                            rate: selectedLoan.base_rate || selectedLoan.rate,
                            points: selectedLoan.points || 0,
                            lender_credit: selectedLoan.lender_credit || 0,
                            monthly_payment: selectedLoan.monthly_payment || 0,
                            closing_cost: selectedLoan.closing_cost || 0
                        }}
                        card={{
                            ...detailedCard, 
                            loanAmount: selectedLoan.loanAmount || filterParams.loanAmount || 400000,
                            estimatedclosingcosts: {
                                ...(closingCostsDetail || detailedCard.closing_costs_detail || {}), 
                                closingcostsfinanced: 0, 
                                deposit: 0, 
                                fundsforborrower: 0, 
                                sellerscredits: 0, 
                                adjustmentsothercredits: 0
                            }, 
                            prepaids: (closingCostsDetail || detailedCard.closing_costs_detail)?.prepaids,
                            rate: selectedLoan.base_rate || selectedLoan.rate,
                            points: selectedLoan.points || 0,
                            lender_credit: selectedLoan.lender_credit || 0,
                            monthly_payment: selectedLoan.monthly_payment || 0,
                            closing_cost: selectedLoan.closing_cost || 0,
                            Lender: selectedLoan.Lender,
                            Name: selectedLoan.Name
                        }}
                        closingCostsDetail={detailType === 'all' ? closingCostsDetail : null}
                    />
                ) : (
                    <div style={{padding: '20px', textAlign: 'center'}}>
                        <p>Loading closing cost details...</p>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ClosingCostFeeModal;